import { render, staticRenderFns } from "./worldBoss.vue?vue&type=template&id=d176ac2a&scoped=true"
import script from "./worldBoss.vue?vue&type=script&lang=js"
export * from "./worldBoss.vue?vue&type=script&lang=js"
import style0 from "./worldBoss.vue?vue&type=style&index=0&id=d176ac2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d176ac2a",
  null
  
)

export default component.exports